import { Controller } from "@hotwired/stimulus"
import { Swiper } from 'swiper'
import { Navigation, Pagination, Thumbs } from 'swiper/modules'

// Connects to data-controller="swiper"
export default class extends Controller {
  static targets = ["container", "thumbs"]

  connect() {
    this.initializeSwiper()
  }

  disconnect() {
    this.destroySwiper()
  }

  initializeSwiper() {
    // Initialize thumbnails swiper first
    if (this.hasThumbsTarget) {
      this.thumbsSwiper = new Swiper(this.thumbsTarget, {
        spaceBetween: 10,
        slidesPerView: 4,
        watchSlidesProgress: true,
        breakpoints: {
          640: {
            slidesPerView: 6,
          },
          768: {
            slidesPerView: 8,
          },
        }
      })
    }

    // Main gallery swiper
    if (this.hasContainerTarget) {
      this.mainSwiper = new Swiper(this.containerTarget, {
        modules: [Navigation, Pagination, Thumbs],
        spaceBetween: 10,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        thumbs: {
          swiper: this.thumbsSwiper
        }
      })
    }
  }

  destroySwiper() {
    if (this.mainSwiper) {
      this.mainSwiper.destroy(true, true)
      this.mainSwiper = null
    }
    
    if (this.thumbsSwiper) {
      this.thumbsSwiper.destroy(true, true)
      this.thumbsSwiper = null
    }
  }

  // Method to reinitialize when content changes
  reinitialize() {
    this.destroySwiper()
    this.initializeSwiper()
  }
}
